import React, { useContext } from "react";
import terrasLogo from "../../assets/images/terras-logo-light.png";
import "./styles.scss";
import UserContext from "../../context/UserContext";

const AuthTemplate = ({ component: Component, ...props }) => {
  const userData = useContext(UserContext);

  return (
    <div className="auth-screen">
      <ul className="auth-item language-options">
        <li>
          <a
            href="#/"
            data-testid="flag-br"
            onClick={() => userData.storeLang("pt-BR")}
          >
            <span className="flag-icon flag-icon-br"></span>
          </a>
        </li>
        <li>
          <a
            href="#/"
            data-testid="flag-us"
            onClick={() => userData.storeLang("en-US")}
          >
            <span className="flag-icon flag-icon-us"></span>
          </a>
        </li>
      </ul>
      <div className="auth-item">
        <form className="auth-box">
          {<Component {...props} />}
          <div className="powered-by">
            <a href="https://terras.agr.br" target="_blank" rel="noopener noreferrer">
              <img src={terrasLogo} alt="Terras logo" />
            </a>
          </div>
        </form>
      </div>
      <div><small>Versão: {import.meta.env.VITE_APP_GIT_REV}</small></div>
    </div>
  );
};

export default AuthTemplate;
